/* eslint-disable no-undef */
export const baseUrl = window.apiUrl?.clinic
    ? window.apiUrl.clinic
    : process.env?.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL
    : '';
